module.exports = __webpack_public_path__ + "img/feature-baby.4a89c501.png";